/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import { v4 as uuidv4 } from 'uuid';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import {
  pushFileInQueue,
  s3FileName,
  getPreWriteSignedWriteUrl,
  s3KeyGenration,
  pushPageUpdateInQueue,
  callOriginalApis,
  uploadPages,
  callProductOriginalApis,
  pushSupplierPageUpdateInQueue,
  callSupplierTemplateOriginalApis,
  callSupplierFilesOriginalApis,
  pushSupplierFilesPageUpdateInQueue,
  pushDppPageinQueue,
  uploadPoFilesToS3,
  callPoFilesOriginalApis,
} from '../../../services/s3Services';
import t from './uploader.type';
import * as customModuleAction from '../../Library/CustomModule/Store/CustomModule.action';
import * as productCustomModuleAction from '../../DevlopmentOrder/store/DevelopmentOrder.action';
import * as action from '../../Supplier/store/Supplier.action';

const ERROR_MESSAGE = 'API connection failed. Please screenshot error and contact your account manager.';

export const uploadSelectedFiles = (file, section, transactionMsg, extraParams, moduleName, urlDevOrderId) => async (dispatch) => {
  try {
    const { s3ImageUrlKeyName, s3ImageCroppedKeyName, s3VideoUrlName, s3VideoThumbnailName } = await s3FileName(file, moduleName, file);
    let resImageUrlName = null;
    let resCroppedURlName = null;
    let resVideoThumbnailName = null;
    let resVideoUrlName = null;
    if (s3ImageUrlKeyName) {
      resImageUrlName = await getPreWriteSignedWriteUrl({ objectKey: s3ImageUrlKeyName, expiresInSeconds: 3600 });
      if (s3ImageCroppedKeyName) {
        resCroppedURlName = await getPreWriteSignedWriteUrl({ objectKey: s3ImageCroppedKeyName, expiresInSeconds: 3600 });
      }
      if (resImageUrlName.code === 200) {
        const taskId = uuidv4();
        const task = {
          taskId,
          s3ImageurlPresignedUrl: resImageUrlName.data,
          fileObj: { ...file, taskId, s3ImageUrlKeyName },
          dispatch,
          t,
          section,
          isFromImageType: true,
          moduleName,
          urlDevOrderId,
        };
        if (s3ImageCroppedKeyName && resCroppedURlName.code === 200) {
          task.isCroppedImage = true;
          task.s3CroppedImagePresignedUrl = resCroppedURlName.data;
          task.fileObj.s3ImageCroppedKeyName = s3ImageCroppedKeyName;
        }
        await pushFileInQueue(task, transactionMsg, extraParams);
      }
    } else if (s3VideoUrlName) {
      resVideoUrlName = await getPreWriteSignedWriteUrl({ objectKey: s3VideoUrlName, expiresInSeconds: 3600 });
      if (s3VideoThumbnailName) {
        resVideoThumbnailName = await getPreWriteSignedWriteUrl({ objectKey: s3VideoThumbnailName, expiresInSeconds: 3600 });
      }
      if (resVideoUrlName.code === 200) {
        const taskId = uuidv4();
        const task = {
          taskId,
          s3VideoPresignedUrl: resVideoUrlName.data,
          fileObj: { ...file, taskId, s3VideoUrlName },
          dispatch,
          t,
          section,
          isFromVideoType: true,
          moduleName,
          urlDevOrderId,
        };
        if (s3VideoThumbnailName && resVideoThumbnailName.code === 200) {
          task.isThumbnailImage = true;
          task.s3ThumbnailImagePresignedUrl = resVideoThumbnailName.data;
          task.fileObj.s3ThumbnailImageKeyName = s3VideoThumbnailName;
        }
        await pushFileInQueue(task, transactionMsg, extraParams);
      }
    }
  } catch (err) {
    console.log('uploadSelectedFilesuploadSelectedFiles', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearUploaderState = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_UPLOADER_FILES,
    });
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

//  function to manage preSignedURLs
export const customModulePages = (file, section, transactionMsg, extraParams) => async (dispatch) => {
  try {
    if (extraParams?.folderId) {
      for (const item of file ?? []) {
        const s3key = await s3KeyGenration(section, extraParams?.folderId, item?._id, null);
        const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });
        if (preSignedURL.code === 200) {
          const task = {
            taskId: item?._id,
            s3PreSignedURL: preSignedURL.data,
            file: { ...item, s3key },
            dispatch,
            t,
            section,
          };
          return await pushPageUpdateInQueue(task, transactionMsg, extraParams);
        }
      }
    } else {
      // addCase
      let finalResponse = false;
      const response = await callOriginalApis(transactionMsg, extraParams, dispatch);
      if (response?.insertedId?.pages?.length > 0) {
        for (const item of file ?? []) {
          const s3key = await s3KeyGenration(section, response?.insertedId?._id, item?._id, null);
          const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });
          if (preSignedURL.code === 200) {
            const uploadConplete = await uploadPages(preSignedURL.data, item);
            if (uploadConplete) {
              finalResponse = true;
            }
          } else {
            await dispatch(customModuleAction.deleteCustomModuleLibrary([response?.insertedId?._id], transactionMsg));
          }
        }
      }
      if (finalResponse) {
        return await dispatch(customModuleAction.getCMPageList(response?.insertedId?._id));
      }
    }
  } catch (err) {
    console.error('customModulePages', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const ProductCustomModulePages = (file, section, transactionMsg, extraParams) => async (dispatch) => {
  try {
    if (extraParams?.devOrderId) {
      if (extraParams?.dbObject?.dataFrom === 'library') {
        // saving directly from library
        let finalResponse = false;
        const response = await callProductOriginalApis(transactionMsg, extraParams, dispatch);
        if (response) {
          for (const item of file ?? []) {
            item.isSupplierVisible = item.isSupplierVisible === undefined || item.isSupplierVisible === null ? true : item.isSupplierVisible;
            const s3keyAdd = await s3KeyGenration(section, extraParams?.folderId, item?._id, extraParams?.devOrderId);
            const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3keyAdd, expiresInSeconds: 3600 });
            if (preSignedURL.code === 200) {
              finalResponse = await uploadPages(preSignedURL.data, item);
            } else {
              // check this code
              delete item.grid;
              const deletedData = {
                customModuleLibId: extraParams?.folderId,
                devOrderId: extraParams?.devOrderId,
                page: item,
              };
              await dispatch(productCustomModuleAction.deletePageFromProductCM(deletedData));
            }
          }
        }
        if (finalResponse) {
          return await dispatch(productCustomModuleAction.getProductCMPageList(params?.devOrderId, params?.folderId));
        }
      } else {
        for (const item of file ?? []) {
          // change before saving
          item.isSupplierVisible = item.isSupplierVisible === undefined || item.isSupplierVisible === null ? true : item.isSupplierVisible;
          const s3key = await s3KeyGenration(section, extraParams?.folderId, item?._id, extraParams?.devOrderId);
          const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });
          if (preSignedURL.code === 200) {
            const task = {
              taskId: item?._id,
              s3PreSignedURL: preSignedURL.data,
              file: { ...item, s3key },
              dispatch,
              t,
              section,
            };
            return await pushPageUpdateInQueue(task, transactionMsg, extraParams);
          }
        }
      }
    }
  } catch (err) {
    console.error('ProductCustomModulePages', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const supplierTemplate = (file, section, transactionMsg, extraParams) => async (dispatch) => {
  try {
    if (extraParams?.folderId) {
      for (const item of file ?? []) {
        const s3key = await s3KeyGenration(section, extraParams?.folderId, item?._id, null);

        const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });

        if (preSignedURL.code === 200) {
          const task = {
            taskId: item?._id,
            s3PreSignedURL: preSignedURL.data,
            file: { ...item, s3key },
            dispatch,
            t,
            section,
          };
          return await pushSupplierPageUpdateInQueue(task, transactionMsg, extraParams);
        }
      }
    } else {
      // addCase
      let finalResponse = false;
      const response = await callSupplierTemplateOriginalApis(transactionMsg, extraParams, dispatch);
      if (response?.insertedId?.pages?.length > 0) {
        for (const item of file ?? []) {
          const s3key = await s3KeyGenration(section, response?.insertedId?._id, item?._id, null);
          const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });
          if (preSignedURL.code === 200) {
            const uploadConplete = await uploadPages(preSignedURL.data, item);
            if (uploadConplete) {
              finalResponse = true;
            }
          }
        }
      }
      if (finalResponse) {
        return await dispatch(action.getCMPageList(response?.insertedId?._id));
      }
    }
  } catch (err) {
    console.error('supplierTemplate', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const suppleirFiles = (file, section, transactionMsg, extraParams) => async (dispatch) => {
  try {
    if (extraParams?.folderId) {
      for (const item of file ?? []) {
        const s3key = await s3KeyGenration(section, extraParams?.docId, item?._id, null, extraParams?.supplierId);
        const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });
        if (preSignedURL.code === 200) {
          const task = {
            taskId: item?._id,
            s3PreSignedURL: preSignedURL.data,
            file: { ...item, s3key },
            dispatch,
            t,
            section,
          };
          await pushSupplierFilesPageUpdateInQueue(task, transactionMsg, extraParams);
          return true;
        }
      }
    } else {
      // addCase
      const response = await callSupplierFilesOriginalApis(transactionMsg, extraParams, extraParams.templateId, dispatch);
      if (response) {
        for (const item of file ?? []) {
          const s3key = await s3KeyGenration(section, response?.data, item?._id, null, extraParams?.supplierId);
          const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600 });
          if (preSignedURL.code === 200) {
            await uploadPages(preSignedURL.data, item);
          }
        }
      }
      return response;
    }
  } catch (err) {
    console.error('customModulePages', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const DppPages = (files, section, transactionMsg, extraParams) => async (dispatch) => {
  try {
    const s3key = await s3KeyGenration(section, extraParams?.path);

    const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600, section });
    if (preSignedURL.code === 200) {
      const task = {
        s3PreSignedURL: preSignedURL.data,
        file: { files, s3key },
        dispatch,
        t,
        section,
      };
      return await pushDppPageinQueue(task, transactionMsg);
    }
  } catch (err) {
    console.error('DppPagesDppPages', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Saves one purchase-order document. A dropped file is pushed to S3 under the PO prefix before
 * its metadata is stored; an Asset Library pick carries only `existingAssetId` in `extraParams`
 * and goes straight to the metadata call, which the server resolves to its own S3 copy.
 */
export const uploadPOFiles = (file, transactionMsg, extraParams) => async (dispatch) => {
  try {
    const { devOrderId, poId, documentId, existingAssetId } = extraParams || {};

    if (file || existingAssetId) {
      if (!poId || poId === 'undefined' || poId === undefined || poId === null) {
        const errorMsg = transactionMsg ? transactionMsg('PURCHASE_ORDER.FILES.PO_ID_REQUIRED') : 'Purchase Order ID is required';
        toasterMsg(errorMsg, 'danger');
        console.error('uploadPOFiles: poId is missing or invalid', { poId, extraParams });
        throw new Error('Purchase Order ID is required');
      }

      if (existingAssetId) {
        return await callPoFilesOriginalApis(transactionMsg, { ...extraParams }, dispatch);
      }

      const s3key = await s3KeyGenration('POFiles', devOrderId, poId, documentId);
      const preSignedURL = await getPreWriteSignedWriteUrl({ objectKey: s3key, expiresInSeconds: 3600, section: 'POFiles' });
      if (preSignedURL.code === 200) {
        const task = {
          s3PreSignedURL: preSignedURL.data,
          file,
          params: { ...extraParams, s3key },
          dispatch,
          t,
          section: 'POFiles',
        };
        return await uploadPoFilesToS3(task, transactionMsg);
      }
    }
  } catch (err) {
    console.log('uploadSelectedFilesuploadSelectedFiles', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export default {
  uploadSelectedFiles,
  clearUploaderState,
  customModulePages,
  ProductCustomModulePages,
  supplierTemplate,
  suppleirFiles,
  DppPages,
  uploadPOFiles,
};
